import api from "./ApiService";
import { getHeaders } from "../helpers/utils";

const getFilter = async () => {
  const res = await api.get("Preference", { headers: getHeaders() });
  return res.data;
};

const saveFilter = async (preference) => {
  const res = await api.post("Preference", preference, {
    headers: getHeaders(),
  });
  return res.data;
};

const PreferenceService = {
  getFilter,
  saveFilter,
};

export default PreferenceService;
